const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/Forms/components/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        noSearchResults: 'Die Suche hat keine Resultate ergeben',
        validationFieldRequired: 'Bitte Pflichtfeld ausfüllen',
        validationSearchOptionRequired: 'Bitte suchen und wählen Sie eine Option',
    },
    __RELATIVE_SOURCE_FILE__
);
